import { h, Component } from 'preact';
import PropTypes from 'prop-types';
import ScheduleServiceFixedTopFormApp from '#/ScheduleServiceFixedTopFormApp';
import MicroModal from 'micromodal';

export default class ScheduleServiceFixedTopFormModal extends Component {
  constructor(props) {
    super(props);

    this.renderForm = this.renderForm.bind(this);
  }

  componentDidMount() {
    if (this.props.open) {
      this.modal = MicroModal.show(this.props.modalId);
    }
  }

  componentDidUpdate() {
    if (this.props.open) {
      this.modal = MicroModal.show(this.props.modalId);
    } else {
      this.modal = MicroModal.close(this.props.modalId);
    }
  }

  renderForm() {
    return (
      <ScheduleServiceFixedTopFormApp
        formId={this.props.modalId}
        services={this.props.services}
        product={this.props.product}
        category={this.props.category}
        brand={this.props.brand}
        link={this.props.link}
        units={this.props.units}
        showUnits={this.props.showUnits}
        showCpf={this.props.showCpf}
        titleForm={this.props.titleForm}
        subtitleForm={this.props.subtitleForm}
        versions={this.props.versions}
      />
    );
  }

  render() {
    return (
      <div
        class="modal micromodal-slide"
        id={this.props.modalId}
        aria-hidden="true"
      >
        <div class="modal__overlay" tabindex="-1" data-micromodal-close>
          <div className="position-relative">
            {this.renderForm()}
          </div>
        </div>
      </div>
    );
  }
}

ScheduleServiceFixedTopFormModal.defaultProps = {
  modalId: 'modal-services',
  open: false,
  services: [],
  brand: '-',
  units: [],
  showUnits: true,
  showCpf: false,
  versions: [],
};

ScheduleServiceFixedTopFormModal.propTypes = {
  modalId: PropTypes.string.isRequired,
  open: PropTypes.bool,
  services: PropTypes.array,
  product: PropTypes.string,
  category: PropTypes.string,
  brand: PropTypes.string,
  link: PropTypes.string,
  units: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.number,
    })
  ),
  showUnits: PropTypes.bool,
  showCpf: PropTypes.bool,
  titleForm: PropTypes.string,
  subtitleForm: PropTypes.string,
  versions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.number,
    })
  ),
};
